import React, { useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import FormHeading from '../../UI_Design/FormComponents/Heading/FormHeading';
import Tabs from './TabsAndContent/Tabs';
import Emp1 from './TabsAndContent/Emp1';
import QualificationDropdown from '../DiyDigilockerNonIBridge/Dropdown';
import EmploymentGapsForm from './EmploymentGapsForm';

const MainFormEmployment = ({ handleDropdownChange }) => {
  const [tabs, setTabs] = useState([]);
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0); // Define currentTab state
  const [showTabs, setShowTabs] = useState(false); // State to control visibility of tabs
  const [showGaps, setShowGaps] = useState(false);
  const [employmentStatus, setEmploymentStatus] = useState("Select status");

  const addEmploymentTab = () => {
    const newTabIndex = tabs.length + 1;
    setTabs([...tabs, { name: `Emp ${newTabIndex}`, path: `emp-${newTabIndex}`, content: <Emp1 /> }]);
    setCurrentTab(newTabIndex - 1); // Set the currentTab to the new tab index
    navigate(`/tabs/emp-${newTabIndex}`); // Navigate to the new tab
  };

  const handleTabContinue = () => {
    if (validateCurrentTab()) {
      const nextTabIndex = currentTab + 1;
      if (nextTabIndex < tabs.length) {
        setCurrentTab(nextTabIndex); // Update currentTab state
        navigate(`/tabs/emp-${nextTabIndex + 1}`);
      }
    } else {
      alert("Please fill in all required fields.");
    }
  };

  const validateCurrentTab = () => {
    // Implement your validation logic here
    return true; // Placeholder, implement your actual validation
  };

  const handleDropdownChangeInternal = (event) => {
    const value = event.target.value;
    setEmploymentStatus(value);
    if (value !== "Select option") {
      setShowTabs(true);
    } else {
      setShowTabs(false);
    }
    // Reset tabs on dropdown change
    setTabs([...tabs, { name: `Emp ${1}`, path: `emp-${1}`, content: <Emp1 /> }]);
    // setTabs([]);
    setCurrentTab(0); // Reset the currentTab index
    // navigate('/tabs/*'); // Navigate to the base tabs path
  };

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <div className="p-3" style={{ background: "#F9FAFB" }}>
            <div className="formHeading mb-5 border-bottom">
              <FormHeading
                heading="Employment"
                subHeading="Add your highest education degree/certificate/all marksheets."
              />
            </div>
            {showTabs && (
              <div className="row d-flex justify-content-end w-100">
                <button
                  className="btn btn-primary mb-3"
                  style={{ position: "relative", bottom: 114, }}
                  onClick={addEmploymentTab}
                >
                  + Add Employment
                </button>
              </div>
            )}
            <div className="row">
              <div className='col-lg-4 col-md-6 col-sm-12'>
                <QualificationDropdown
                  label="Current Employment Status"
                  labelStyle={{ color: '#6B7280' }}
                  options={[
                    "I'm a Fresher",
                    "I'm currently unemployed (previously employed)",
                    "I'm currently employed with [BGV Company Name]",
                    "I'm currently employed with another company"
                  ]}
                  value={employmentStatus}
                  onChange={handleDropdownChangeInternal}
                />
              </div>
            </div>
            {showTabs && (
              <div>
                <Tabs tabs={tabs} />
                <Routes>
                  <Route path="/" element={<Navigate to="emp-1" replace />} />
                  {tabs.map(tab => (
                    <Route key={tab.path} path={tab.path} element={tab.content} />
                  ))}
                </Routes>
              </div>
            )}
            {showGaps && (
              <EmploymentGapsForm />
            )}
            <div className="d-flex justify-content-start align-items-center my-5 pt-5">
              <button
                className="btn font-weight-bold btn-outline-secondary"
                onClick={() => {
                  // Handle back functionality here if needed
                }}
              >
                Back
              </button>
              {showTabs && (
                <button
                  className="btn font-weight-bold btn-primary ml-2"
                  onClick={handleTabContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default MainFormEmployment;
